import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import viewName from '../constant.js'
import {
    AddressEdit
} from 'vant'
import areaCard from '@/components/areaCard/areaCard.vue'
import {
    saveAddress,
    getAddressInfoById
} from '@/models/editAddress'
import {
    isInvalidPhone
} from '@/utils/REG'
import {
    throttle
} from 'lodash'
export default {
    name: viewName.editAddress,
    components: {
        'van-address-edit': AddressEdit,
        'area-card': areaCard
    },
    data () {
        return {
            isBack: true,
            delivery_id: '',
            selectedText: '', // 展示
            // areaList,
            addressInfo: {
                name: ''
            },
            defaultRegion: {},
            addressForm: {
                name: '',
                phone_number: '',
                area_id: '',

                addressDetail: ''
            },
            searchResult: []
        }
    },
    watch: {
        // '$route.query.delivery_id' (v) {}
    },
    computed: {
        ...mapState({}),
        ...mapGetters(['area'])
    },
    created () {
        if (this.$route.query.delivery_id) {
            this.delivery_id = this.$route.query.delivery_id
            this.apiGetDelivery({
                delivery_id: this.$route.query.delivery_id
            })
        } else {
            this.addressForm = {
                name: '',
                phone_number: '',
                area_id: '',
                addressDetail: ''
            }
        }
    },
    activated () {},
    async mounted () {},
    methods: {
        ...mapActions(['getRegion', 'setAddressInfo', 'changeRecipientMember', 'editRecipientStatus', 'editRegion']),
        onSave () {
            // Toast('save')
        },
        onDelete () {
            // Toast('delete')
        },
        onChangeDetail (val) {
            // if (val) {
            //     this.searchResult = [{
            //         name: '黄龙万科中心',
            //         address: '杭州市西湖区'
            //     }]
            // } else {
            //     this.searchResult = []
            // }
        },
        // 打开地域
        openArea () {
            this.$refs.areacard.open()
        },
        confirm (text) {
            this.selectedText = text || ''
        },
        // 保存
        save: throttle(function () {
            // {
            // let { name, phone_number, addressDetail } = this.addressForm
            // 判断是否从编辑进来。否则不进行修改
            if (this.isBack) {
                this.validate()
                    .then(async ({
                        name,
                        phone_number,
                        addressDetail
                    }) => {
                        this.isBack = false
                        if (this.delivery_id) {
                            this.setAddressInfo({
                                delivery_id: this.delivery_id,
                                consignee: name,
                                address: addressDetail,
                                phone_tel: phone_number,
                                region_name: this.selectedText
                            })
                        }
                        await saveAddress({
                            delivery_id: this.delivery_id,
                            consignee_name: name,
                            consignee_tel: phone_number,
                            district_detail: addressDetail,
                            district_id: this.area.selected_county.id
                        })

                        //   this.apiGetDelivery({
                        //     delivery_id: this.$route.query.delivery_id
                        // })
                        // 修改当前选择的
                        this.changeRecipientMember('mail')
                        this.editRecipientStatus(true)

                        // this.openAddressList
                        this.$router.go(-1)
                        this.$toast('保存成功')
                    })
                    .catch(err => {
                        this.$toast(err)
                    })
            }

            // }
        }, 300),
        async apiGetDelivery (data) {
            let back = await getAddressInfoById(data)
            this.addressForm = {
                name: back.consignee,
                phone_number: back.phone_tel,
                area_id: back.region_id,
                addressDetail: back.address
            }
            this.selectedText = back.region_name
            this.defaultRegion = {
                province_id: back.province,
                region_id: back.region_id,
                city_id: back.city
            }
            const regionText = this.selectedText.split(' ')
            this.editRegion({
                selected_prov: {
                    text: regionText[0],
                    id: back.province
                },
                selected_city: {
                    text: regionText[1],
                    id: back.city
                },
                selected_county: {
                    text: regionText[2],
                    id: back.region_id
                }
            })
            // this.user.province_list.findIndex(item => item.id ===  back.province)
            // this.user.county_list.findIndex(item => item.id ===  back.region_id)
            // this.user.city_list.findIndex(item => item.id ===  back.city)
            // 找出默认的地区
        },
        // 保存前的验证
        validate () {
            return new Promise((resolve, reject) => {
                let {
                    name,
                    phone_number,
                    addressDetail,
                } = this.addressForm
                let {
                    selectedText
                } = this
                // 判断是数据的完整性，严谨性
                if (!name) {
                    reject(String('请填写收货人姓名'))
                }
                // 用户未完善手机号码
                if (!phone_number) {
                    reject(String('请填写车主手机号码'))
                } else if (!isInvalidPhone(phone_number)) {
                    reject(String('手机号码格式有误'))
                }
                if (!addressDetail) {
                    reject(String('请填写详细地址'))
                }
                if (!selectedText) {
                    reject(String('请选择所在地区'))
                }
                resolve(this.addressForm)
            })
        }
    },
    destroyed () {
        this.isBack = true
    }
}
